import businessValues from './businessValues'
import serviceValuesKKday from './serviceValuesKKday'
import orderStatusKKday from './orderStatusKKday'
import eventConstants from './eventConstants'
import defaultDateTypes from './defaultDateTypes'
import bKeyPermission from './bKeyPermission'
import serviceWhiteList from './serviceWhiteList'

export default {
  ...bKeyPermission,
  ...businessValues,
  ...serviceValuesKKday,
  ...orderStatusKKday,
  imgApiUrl: process.env.VUE_APP_IMAGE_API_URL || 'https://img.sit.kkday.com',
  kkdayWebUrl: process.env.VUE_APP_KKDAY_WEB_PC_URL || 'https://www.sit.kkday.com',
  kkdayWebMUrl: process.env.VUE_APP_KKDAY_WEB_M_URL || 'https://m.sit.kkday.com',
  kkdayPrivacyPolicyPageUrl: 'https://event.kkday.com/en/about/privacy',
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  ...eventConstants,
  ...defaultDateTypes,
  DATE_FORMAT: 'YYYY/MM/DD',
  ...serviceWhiteList
}
